// extracted by mini-css-extract-plugin
module.exports = {"body":"ContractData_body__14qNW","checkbox":"ContractData_checkbox__2j8Ux","modalText":"ContractData_modalText__JWrsD"};